// extracted by mini-css-extract-plugin
export var container = "Tabs-module--container--c08b7";
export var tab = "Tabs-module--tab--93681";
export var tabActive = "Tabs-module--tab-active--57347";
export var tabContent = "Tabs-module--tab-content--18802";
export var tabsList = "Tabs-module--tabs-list--cc0d7";